/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdateProfileSkillRequest } from './';
import {
    UpdateProfileSkillRequestFromJSON,
    UpdateProfileSkillRequestFromJSONTyped,
    UpdateProfileSkillRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateProfileRemainingSkillsRequest
 */
export interface UpdateProfileRemainingSkillsRequest {
    /**
     * 
     * @type {Array<UpdateProfileSkillRequest>}
     * @memberof UpdateProfileRemainingSkillsRequest
     */
    remainingSkills: Array<UpdateProfileSkillRequest>;
}

/**
 * Check if a given object implements the UpdateProfileRemainingSkillsRequest interface.
 */
export function instanceOfUpdateProfileRemainingSkillsRequest(value: object): value is UpdateProfileRemainingSkillsRequest {
    if (!('remainingSkills' in value) || value['remainingSkills'] === undefined) return false;
    return true;
}

export function UpdateProfileRemainingSkillsRequestFromJSON(json: any): UpdateProfileRemainingSkillsRequest {
    return UpdateProfileRemainingSkillsRequestFromJSONTyped(json, false);
}

export function UpdateProfileRemainingSkillsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileRemainingSkillsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'remainingSkills': ((json['remainingSkills'] as Array<any>).map(UpdateProfileSkillRequestFromJSON)),
    };
}

export function UpdateProfileRemainingSkillsRequestToJSON(value?: UpdateProfileRemainingSkillsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'remainingSkills': ((value['remainingSkills'] as Array<any>).map((v) => UpdateProfileSkillRequestToJSON(v))),
    };
}

